const AppConst = {
  

//BASE_URL:"https://sr.webhospi.in/",


//BASE_URL:"https://shrc.webhospi.in/",
//BASE_URL:"https://nilachal.webhospi.in/",




//ONLINE_URL: "https://brahma.websmart.org.in/",
//ONLINE_URL: "https://galaxy.webhospi.in/",

ONLINE_URL: "https://demo.webhospi.in/",
//PUBLIC_APP_URL: "https://demo.webhospi.in/",
PUBLIC_APP_URL: "https://demohosp.webhospi.in/",
//ONLINE_URL: "https://central.centrallabglp.in/",
//ONLINE_URL: "https://apexbackend.apexhealthcare.in/",
 //ONLINE_URL: "https://maxlab.websmart.org.in/",
// ONLINE_URL: "https://aastha.webhospi.in/",


  // Local Server (Offline)
  LOCAL_URL: "http://localhost/demo/",
  
  // Current active URL (will be set dynamically)
  //BASE_URL: "http://localhost/demo/",




  payLabFromAdvanceUrl: '/pay_lab_from_advance',
  payPharmacyFromAdvanceUrl: '/pay_pharmacy_from_advance',
  processIpdReturnUrl: '/process_ipd_return',
  getIpdReturnHistoryUrl: '/get_ipd_return_history',
  getIpdReturnAccountsUrl: '/get_ipd_return_accounts',
  getAdvanceUsageUrl: '/get_advance_usage',


  syncHealthUrl: 'sync_apis/health',
  syncToOnlineUrl: 'sync_apis/sync_to_online',
  syncStatusUrl: 'sync_apis/get_sync_status',
  syncPendingCountUrl: 'sync_apis/get_pending_count',


  syncFromOnlineUrl:'sync_apis/sync_from_online',


  loginUrl: 'web_apis/login_now',
  signupUrl: 'web_apis/register_now',
  forgotUrl: 'web_apis/forgot_now',
  upProfileUrl: 'web_apis/profile_up_now',
  getProfileUrl: 'web_apis/get_profile_by_id',
  upProfileUrl1: 'web_apis/profile_up_now1',
  getProfileUrl1: 'web_apis/get_profile_by_id1', 
  upProfileUrl2: 'web_apis/profile_up_now2',
  upconfigUrl: 'web_apis/update_config_logos',
  getconfig: 'web_apis/get_config_logos',
  getProfileUrl2: 'web_apis/get_profile_by_id2',
  storeUpdateUrl: 'web_apis/store_update',
  getStoreByIdUrl: 'web_apis/get_store_by_id',
  CreateStoreHns: 'web_apis/create_store_hsn', 
  GetAllStoreHns: 'web_apis/get_store_hsn_list',
  addSampleUrl: "Labregcon/add_sample_url",

// Lab refund URLs
addLabRefundUrl: 'lab_reg_apis/add_lab_refund',
getLabRefundHistoryUrl: 'lab_reg_apis/get_lab_refund_history',
deleteLabRefundUrl: 'lab_reg_apis/delete_lab_refund',



  itemSaveUrl: "web_apis/create-store-item",
itemListUrl: "get_store_items",
itemDeleteUrl: "web_apis/delete-store-item",
getNextPurchaseNoUrl: "get_next_purchase_no",

  CreateStoreUnits: 'web_apis/create-store-unit', 
  GetAllStoreUnits: 'web_apis/get-store-units',
  DeleteUnitUrl: 'web_apis/delete-store-unit',
  CreateStoreDepartment: "web_apis/create-store-department",
  GetAllStoreDepartments: "web_apis/get-store-departments",
  DeleteStoreDepartment: "web_apis/delete-store-department",

  GetAllRole: 'web_apis/get_role_list',
  GetAllModules: 'web_apis/get_modules_list',
  UpdateModulAssign: 'web_apis/update_role_modules',
  GetModuleAssign: 'web_apis/get_role_modules',
  
  upIntiNowUrl: 'web_apis/inti_up_now',
  getIntiByUserUrl: 'web_apis/get_inti_by_id',

  addCatUrl: 'cat_apis/create_cat_now',
  delCatUrl: 'cat_apis/del_cat',
  getCatByIdUrl: 'cat_apis/get_cat_by_id',
  getCatListUrl: 'cat_apis/get_cat_list',
  delAllCatUrl: 'cat_apis/delete_all_cats',
  updateCatDefaultUrl: 'cat_apis/update_cat_default',

  addunitmed: 'Webapis/create_unit_now',
  

  // ===== UHID =====
getUhidSettingsUrl:  "web_apis/get_uhid_settings",
saveUhidSettingsUrl: "web_apis/save_uhid_settings",
previewUhidUrl:      "web_apis/preview_uhid",
getUhidMasterUrl:    "web_apis/get_uhid_master",

  addMedUrl: 'med_apis/save_med',
  delMedUrl: 'med_apis/delete_med',
  getMedByIdUrl: 'med_apis/get_med_by_id',
  getMedListUrl: 'med_apis/get_med_list',
  delAllMedUrl: 'med_apis/delete_multiple_meds',

  getPurchaseForEditUrl: 'Purchasecon/get_purchase_for_edit',
  
  addUserUrl: 'user_apis/create_user_now',
  delUserUrl: 'user_apis/del_user',
  getUserByIdUrl: 'user_apis/get_user_by_id',
  getUserListUrl: 'user_apis/get_user_list',
  deleteAllUsersUrl: 'user_apis/delete_all_users',

  addBranchUrl:       'user_apis/create_branch',
  getBranchListUrl:   'user_apis/get_branch_list',
  getBranchByIdUrl:   'user_apis/get_branch_by_id',
  delBranchUrl:       'user_apis/del_branch',


  SaveSalaryStructure:    'user_apis/save_salary_structure',
  GetSalaryStructures:    'user_apis/get_salary_structures',
  GetSalaryByUser:        'user_apis/get_salary_structure_by_user',
  DeleteSalaryStructure:  'user_apis/delete_salary_structure',
  ProcessPayroll:         'user_apis/process_payroll',
  GetPayrollList:         'user_apis/get_payroll_list',
  MarkPayrollPaid:        'user_apis/mark_payroll_paid',
  DeletePayroll:          'user_apis/delete_payroll',






  addBedUrl: 'bed_apis/create_bed_now',
  delBedUrl: 'bed_apis/del_bed',
  getBedByIdUrl: 'bed_apis/get_bed_by_id',
  getBedListUrl: 'bed_apis/get_bed_list',
  getBedListUrl1: 'bed_apis/get_bed_list_har',
  delAllBedUrl: 'bed_apis/delete_all_beds',
  transferBedUrl: 'bed_apis/transfer_bed',





  addIpdUrl: 'ipd_apis/create_ipd',
  delIpdUrl: 'ipd_apis/del_ipd',
  getIpdByIdUrl: 'ipd_apis/get_ipd_by_id',
  getIpdListUrl: 'ipd_apis/get_ipd_list',
  delAllIpdUrl: 'ipd_apis/delete_all_ipds',
  getIpdListUrl2: 'ipd_apis/get_ipd_list2',
  getIpdListUrl3: 'ipd_apis/get_ipd_list3',
  getIpdDischargedUrl:'ipd_apis/get_ipd_discharged_list',
  getIpdDischargedUrl3:'ipd_apis/get_ipd_discharged_list3',
  getIpdDischargedUrl4:'ipd_apis/get_ipd_discharged_list4',
  addEmergencyUrl: 'ipd_apis/add_emergency_patient',
  getEmergencyListUrl:'ipd_apis/get_emergency_list',

  getNextIpdNoUrl:'ipd_apis/get_next_ipd_no',

  delEmergencyUrl: 'ipd_apis/del_emergency',
getEmergencyByIdUrl: 'ipd_apis/get_emergency_by_id',
moveEmergencyToIPDUrl: 'ipd_apis/move_emergency_to_ipd',

  getIpdBillItemsUrl : 'ipd_apis/get_ipd_bill_items',
  getIpdDischargedPdfUrl: 'ipd_apis/export_ipd_discharged_pdf',
  ipdpaydoctor:"ipd_apis/pay_doctor_services",



  // ===== MLC (Medico Legal Case) =====
createMlcUrl:   "ipd_apis/create_mlc_now",
getMlcListUrl:  "ipd_apis/get_mlc_list",
getMlcByIdUrl:  "ipd_apis/get_mlc_by_id",
getMlcNextNoUrl:"ipd_apis/get_mlc_next_no",
deleteMlcUrl:   "ipd_apis/delete_mlc",


  addOtUrl: 'ot_apis/save_ot',
  delOtUrl: 'ot_apis/delete_ot',
  getOtByIdUrl: 'ot_apis/get_ot_by_id',
  delAllOtUrl: 'ot_apis/delete_multiple',
  getOtListUrl: 'ot_apis/get_ot_list',
  getOtItemListUrl: 'ot_apis/get_ot_item_list',

 saveOtFormatBtnUrl      : "ot_apis/save_ot_format_btn",
  getOtFormatBtnsUrl      : "ot_apis/get_ot_format_btns",
  deleteOtFormatBtnUrl    : "ot_apis/delete_ot_format_btn",
  saveOtFormatPageUrl     : "ot_apis/save_ot_format_page",
 getOtFormatPagesUrl     : "ot_apis/get_ot_format_pages",
deleteOtFormatPageUrl  : "ot_apis/delete_ot_format_page",
getOtFormatAllUrl      :"ot_apis/get_ot_format_all",


  addIpdBillUrl: 'ipd_bill_apis/create_ipd_bill',
 
  getIpdBillListUrl: 'ipd_bill_apis/get_ipd_bill_list',
  getIpdBillByIdUrl: 'ipd_bill_apis/get_ipd_bill_by_id',
  delIpdBillUrl: 'ipd_bill_apis/del_ipd_bill',
  PaymentIpdBillUrl: 'ipd_bill_apis/add_payment_transaction',
  GetPaymentIpdBill: 'ipd_bill_apis/get_payment_history',
  GetPaymentIpdBill2: 'ipd_bill_apis/get_payment_history2',
  // In your appconst.js file, add:
deletePaymentTransactionUrl: 'ipd_bill_apis/delete_payment_transaction',
  delAllIpdBillsUrl: 'ipd_bill_apis/delete_all_ipd_bills',
  ChangePassword:'user_apis/change_password',
  GetCaseDetailsUrl:'ipd_bill_apis/get_case_details',
  markDischargedUrl:'ipd_bill_apis/mark_discharged',
  UpdateIpdStatusBoth2:'ipd_bill_apis/UpdateIpdStatusBoth',
  payIpdDoctorCommissionUrl:'ipd_bill_apis/pay_ipd_doctor_commission',
  payIpdBrokerCommissionUrl:'ipd_bill_apis/pay_ipd_broker_commission',
  addSignUrl: 'sign_apis/create_sign_now',
  delSignUrl: 'sign_apis/del_sign',
  getSignByIdUrl: 'sign_apis/get_sign_by_id',
  getSignByDepartUrl: 'sign_apis/get_sign_by_depart',
  getSignListUrl: 'sign_apis/get_sign_list',
  delAllSignUrl: 'sign_apis/delete_all_signs',

  addTestUrl: 'test_apis/create_test_now',
  delTestUrl: 'test_apis/del_test',
  getTestByIdUrl: 'test_apis/get_test_by_id',
  getTestListUrl: 'test_apis/get_test_list',
  delAllTestUrl: 'test_apis/delete_all_tests',

// Add these to your AppConst file
getTestDepartmentsUrl: "test_apis/get_test_departments",
createTestDepartmentUrl: "test_apis/create_test_department",
deleteTestDepartmentUrl: "test_apis/delete_test_department",


  // Add this in your AppConst.js
getIpdAdvancePaymentsUrl: 'ipd-advance/get',
addIpdAdvanceUrl: 'ipd-advance/add',
deleteIpdAdvanceUrl: 'ipd-advance/delete',

// Add this to your AppConst.js file
getDaybookTransactionsUrl: 'ipd-advance/get_daybook_transactions',
getBalanceSheetUrl: 'ipd-advance/getBalanceSheet',

getServiceGroupsUrl:   'ipd-advance/getServiceGroups',
saveServiceGroupUrl:   'ipd-advance/saveServiceGroup',
 delServiceGroupUrl:    'ipd-advance/delServiceGroup',
  getIpdNetCollectionUrl:'ipd-advance/getIpdNetCollection',

  addTestParamUrl: 'test_param_apis/create_test_param_now',
  delTestParamUrl: 'test_param_apis/del_test_param',
  getTestParamByIdUrl: 'test_param_apis/get_test_param_by_id',
  getTestParamListUrl: 'test_param_apis/get_test_param_list',
  delAllTestParamUrl: 'test_param_apis/delete_all_test_params',

  getTestParamItemsUrl: 'test_param_apis/get_test_param_items',
  saveTestParamItemsUrl: 'test_param_apis/save_test_param_items',

  updateReportResultUrl: 'testreport_apis/update_test_report',

  addTestReportUrl: 'testreport_apis/create_test_report',
  delTestReportUrl: 'testreport_apis/del_test_report',
  getTestReportByIdUrl: 'testreport_apis/get_test_report_by_id',
  getTestReportListUrl: 'testreport_apis/get_test_report_list',
  delAllTestReportUrl: 'testreport_apis/delete_all_test_reports',
  getTestReportItemListUrl: 'testreport_apis/get_test_report_itm_list',
  approveTestReportUrl: 'testreport_apis/approve_test_report',
  send_lab_report_whatsapp: 'testreport_apis/send_lab_report_whatsapp',
  send_lab_report_pdf_whatsapp: 'testreport_apis/send_lab_report_pdf_whatsapp',
  getReportConfigUrl:  "testreport_apis/get_report_config",
  saveReportConfigUrl: "testreport_apis/save_report_config",



  getStockUsageHistoryUrl: 'testreport_apis/get_stock_usage_history',
  manualReduceStockUrl: 'testreport_apis/manual_reduce_stock',
  getPatientsForStockUseUrl: 'testreport_apis/get_patients_for_stock_use',


  scanImportFolderUrl: "LisImportController/scan_import_folder",
    autoImportResultsUrl: "LisImportController/auto_import_results",
    getImportStatsUrl: "LisImportController/get_import_stats",



    fetchMachineResultsUrl: "lis-import/fetch_machine_results",
markResultsConsumedUrl: "lis-import/mark_results_consumed",


  addOpdUrl: 'opd_apis/create_opd',
  delOpdUrl: 'opd_apis/del_opd',
  getOpdByIdUrl: 'opd_apis/get_opd_by_id',
  getOpdListUrl: 'opd_apis/get_opd_list',
  delAllOpdUrl: 'opd_apis/delete_all_opds',
  getOpdValListUrl: 'opd_apis/get_opd_val_list',
  updateOpdDoneUrl: 'opd_apis/update_opd_done',
  savePrescriptionUrl: 'opd_apis/save_prescription',
  getPrescriptionUrl:'opd_apis/get_prescription',
  prescriptionTemplateUrl: "opd_apis/prescription_template",



  getBrokerReferralOpdUrl: 'opd_apis/get_broker_referral_opd',
  getBrokerReferralPharmacyUrl: 'medbill_apis/get_broker_referral_pharmacy',
  payBrokerCommissionOpdUrl: 'opd_apis/payBrokerCommissionOpd',
  payBrokerCommissionPharmacyUrl: 'medbill_apis/payBrokerCommissionPharmacy',


  doctorSlotUrl: "opd_apis/doctor_slot",
  ancFileUrl: "opd_apis/anc_file",
  opdPaymentUrl: 'opd_apis/opd_payment',
saveProcedureBillUrl: 'opd_apis/save_procedure_bill',
getProcedureBillUrl: 'opd_apis/get_procedure_bill',
getProcedureBillsListUrl: "opd_apis/get_procedure_bills_list",
delete_procedure_bill : "opd_apis/delete_procedure_bill",
markOpdInProgressUrl: 'opd_apis/mark_opd_in_progress',
// Add this to your AppConst.js
payProcedureBillUrl: 'opd_apis/pay_procedure_bill', // or your endpoint name
getProcedureBillPaymentsUrl: 'opd_apis/get_procedure_bill_payments', // optional
// OPD refund URLs
opdRefundUrl: 'opd_apis/opd_refund',
getOpdRefundHistoryUrl: 'opd_apis/get_opd_refund_history',

saveOpdFormatUrl :"opd_apis/save_opd_format",
getOpdFormatsUrl  :"opd_apis/get_opd_formats",
getOpdFormatBySpecUrl : "opd_apis/get_opd_format_by_speciality",
deleteOpdFormatUrl  : "opd_apis/delete_opd_format",



  addMedBillUrl: 'medbill_apis/create_med_bill',
  //delMedBillUrl: 'medbill_apis/del_med_bill',
  getMedBillByIdUrl: 'medbill_apis/get_med_bill_by_id',
  getMedBillListUrl: 'medbill_apis/get_med_bill_list',
  payMedBillUrl: 'medbill_apis/pay_med_bill',
  getPharmacyPaymentHistoryUrl: 'medbill_apis/get_pharmacy_payment_history',
  // Add this constant
getPharmacyAccountsUrl: 'medbill_apis/get_pharmacy_accounts',
  searchMedBillUrl: "medbill_apis/search_med_bill",
  createReturnBillUrl: "medbill_apis/create_return_bill",
  getReturnListUrl: "medbill_apis/get_return_list",
  getReturnDetailsUrl: "medbill_apis/get_return_details",

  getReturnDetailsWithOriginalUrl: "medbill_apis/get_return_details_with_original",

  addMedPaymentUrl: "medbill_apis/add_med_payment",
  getMedPaymentHistoryUrl: "medbill_apis/get_med_payment_history",
  //deleteMedPaymentUrl: "medbill_apis/delete_med_payment",
  deleteReturnUrl: 'medbill_apis/delete_return',
  getProfitLossReportUrl: 'medbill_apis/get_profit_loss_report',
  getMedPaymentTransactionsUrl: "medbill_apis/get_med_payment_transactions",
// ✅ Add these to your existing AppConst.js file

// Purchase Transaction APIs
getSuppliersWithDueUrl: "purchase_apis/get_suppliers_with_due",
getSupplierPurchasesUrl: "purchase_apis/get_supplier_purchases",
getPurchaseTransactionsUrl: "purchase_apis/get_purchase_transactions",
createPurchaseTransactionUrl: "purchase_apis/create_purchase_transaction",
deletePurchaseTransactionUrl: "purchase_apis/delete_purchase_transaction",
createSupplierDirectPaymentUrl: "purchase_apis/create_supplier_direct_payment",
getStockReportUrl:"purchase_apis/get_stock_report",



getPurchaseForReturnUrl:"purchase_apis/get_purchase_for_return",

savePurchaseReturnUrl:"purchase_apis/save_purchase_return",

getReturnsByPurchaseUrl:"purchase_apis/get_returns_by_purchase",
getReturnInvoiceUrl:"purchase_apis/get_return_invoice",

getMedicineSaleHistoryUrl:"purchase_apis/get_medicine_sale_history",

getExpiringMedicinesUrl: "purchase_apis/get_expiring_medicines",
getGstReportUrl:"purchase_apis/get_gst_report",
  addPurchaseUrl: 'purchase_apis/create_purchase',
  delPurchaseUrl: 'purchase_apis/del_purchase',
  getPurchaseByIdUrl: 'purchase_apis/get_purchase_by_id',
  getPurchaseListUrl: 'purchase_apis/get_purchase_list',
  makePurchasePaymentUrl: 'purchase_apis/update_purchase_payment',
  deletePurchaseItemUrl:'purchase_apis/delete_purchase_item',
  addStorePurchaseUrl: 'store_purchase_apis/create_store_purchase',
  delStorePurchaseUrl: 'store_purchase_apis/del_store_purchase',
  getStorePurchaseByIdUrl: 'store_purchase_apis/get_store_purchase_by_id',
  getStorePurchaseListUrl: 'store_purchase_apis/get_store_purchase_list',
  supplierStoreInvoiceActionUrl: 'store_purchase_apis/supplier_store_invoice_action',



  saveStoreSaleUrl: "store_controller/save_store_sale",
  getStoreSalesUrl: "store_controller/get_store_sales",
  getSaleDetailsUrl: "store_controller/get_sale_details",
  deleteStoreSaleUrl: "store_controller/delete_store_sale",
  getStoreStockUrl: "store_controller/get_store_stock",

  searchStoreItemsUrl: 'store_purchase_apis/search_store_items',

  addCertUrl: 'cert_apis/create_cert_now',
  delCertUrl: 'cert_apis/del_cert',
  getCertByIdUrl: 'cert_apis/get_cert_by_id',
  getCertListUrl: 'cert_apis/get_cert_list',
  deleteAllCertsUrl: 'cert_apis/delete_all_certs',

  addAmbulanceUrl: 'ambulance_apis/create_ambulance_now',
  delAmbulanceUrl: 'ambulance_apis/del_ambulance',
  getAmbulanceByIdUrl: 'ambulance_apis/get_ambulance_by_id',
  getAmbulanceListUrl: 'ambulance_apis/get_ambulance_list',
  deleteAllAmbulancesUrl: 'ambulance_apis/delete_all_ambulances',


  addMedSheetUrl: 'med_sheet_apis/create_med_sheet_now',
  delMedSheetUrl: 'med_sheet_apis/del_med_sheet',
  getMedSheetByIdUrl: 'med_sheet_apis/get_med_sheet_by_id',
  getMedSheetListUrl: 'med_sheet_apis/get_med_sheet_list',
  deleteAllMedSheetsUrl: 'med_sheet_apis/delete_all_med_sheets',


  addTpaUrl2: 'tpa_apis/create_tpa_now',
  delTpaUrl2: 'tpa_apis/del_tpa',
  
  getTpaByIdUrl: 'tpa_apis/get_tpa_by_id',
  getTpaListUrl2: 'tpa_apis/get_tpa_list',
  deleteAllTpasUrl: 'tpa_apis/delete_all_tpas',
  getOtByUhidUrl:'tpa_apis/get_ot_by_uhid',

  addLabRegUrl: 'lab_reg_apis/create_lab_reg',
   UpdateIpdBillUrl: 'lab_reg_apis/update_ipd_bill_notes',
   UpdateIpdStatusBoth: 'lab_reg_apis/update_ipd_status_both',
   Get_cases_by_uhid: 'ipd_bill_apis/get_cases_by_uhid',

  delLabRegUrl: 'lab_reg_apis/del_lab_reg',
  getLabRegByIdUrl: 'lab_reg_apis/get_lab_reg_by_id',
  getLabRegListUrl: 'lab_reg_apis/get_lab_reg_list',
  getLabRegListItmUrl: 'lab_reg_apis/get_lab_reg_itm_list',
  delAllLabRegsUrl: 'lab_reg_apis/delete_all_lab_regs',
  searchUhidUrlCall: 'lab_reg_apis/search_uhid',
  checkUhidDueCall: 'lab_reg_apis/check_due_amount',
  upPayUrl: 'lab_reg_apis/up_pay_now',
  upSampleUrl: 'lab_reg_apis/add_sample_url',
  getBarcodeConfigUrl:  "lab_reg_apis/get_barcode_config",
   saveBarcodeConfigUrl: "lab_reg_apis/save_barcode_config",
  GetDashboard: 'lab_reg_apis/get_dashboard_stats',
  getLabAccountsSummaryUrl:'lab_reg_apis/get_lab_accounts_summary',

  addPaymentUrl: "lab_reg_apis/add_payment",
  getPaymentHistoryUrl: "lab_reg_apis/get_payment_history",
  deletePaymentUrl: "lab_reg_apis/delete_payment",
  getPaymentTransactionsUrl: "lab_reg_apis/get_payment_transactions",
  getDocTestCommissionUrl: "lab_reg_apis/get_doc_test_commission",   // fetch list for a doctor
  // (you already have getTestListUrl — we'll reuse that for search)




  collectAccountUrl: 'Webapis/collect_account',

  addExpenseUrl:'Webapis/add_expense',
  getExpensesListUrl:'Webapis/get_expenses_list',
  delExpenseUrl:'Webapis/del_expense',

  addInsuranceUrl:'Webapis/add_insurance',
  getInsuranceListUrl:'Webapis/get_insurance_list',
  delInsuranceUrl:'Webapis/del_insurance',
  getDoctorReferralLabUrl:'lab_reg_apis/get_doctor_referral_lab',
  payBrokerCommissionUrl:'lab_reg_apis/payBrokerCommission',
  payDoctorCommissionUrl:'lab_reg_apis/payDoctorCommission',
  addTpaUrl:'Webapis/add_tpa',
  getTpaListUrl:'Webapis/get_tpa_list',
  delTpaUrl:'Webapis/del_tpa',


  addBrokerUrl: 'Webapis/add_broker',      // POST
getBrokerListUrl: 'Webapis/get_broker_list', // POST
delBrokerUrl: 'Webapis/del_broker',      // POST

  aiChatUrl:'Webapis/chat',
  //getPatientHistoryUrl:'Webapis/get_patient_history',
  getPatientHistoryUrl:'ipd_bill_apis/get_patient_history',
  GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || 'AIzaSyBT4NQnzzQT_88pEfvalegfLb0zXOkCcxY',




  getFast2SMSConfig: "Webapis/getFast2SMSConfig",
  saveFast2SMSConfig: "Webapis/saveFast2SMSConfig",
  updateTemplate:"Webapis/updateTemplate",
  // Template Management
  getTemplates: "Webapis/getTemplates",
  saveTemplate: "Webapis/saveTemplate",
  deleteTemplate: "Webapis/deleteTemplate",
  
  // Module Settings (Toggle switches)
  getModuleSettings: "Webapis/getModuleSettings",
  updateModuleSetting: "Webapis/updateModuleSetting",
  
  // Message Logs
  getWhatsAppLogs: "Webapis/getWhatsAppLogs",
  
  // Send Functions (for manual triggers or integration)
  sendLabReportWhatsApp: "Webapis/sendLabReportWhatsApp",
  sendLabBillWhatsApp: "Webapis/sendLabBillWhatsApp",
  sendOPDBillWhatsApp: "Webapis/sendOPDBillWhatsApp",
  sendDigitalPrescriptionWhatsApp: "Webapis/sendDigitalPrescriptionWhatsApp",
  sendIPDAdmissionBillWhatsApp: "Webapis/sendIPDAdmissionBillWhatsApp",
  sendIPDBillWhatsApp: "Webapis/sendIPDBillWhatsApp",
  sendPharmacySaleBillWhatsApp: "Webapis/sendPharmacySaleBillWhatsApp",
  sendPharmacyReturnBillWhatsApp: "Webapis/sendPharmacyReturnBillWhatsApp",


  CheckLicenseStatus: "LicenseController/check_license_status",
  CreateRenewalOrder: "LicenseController/create_renewal_order",
  VerifyAndRenew: "LicenseController/verify_and_renew",
  getReportForQRUrl: "testreportcon/get_report_for_qr",

  CheckServerLock: 'LicenseController/check_server_lock',
ActivateServer: 'LicenseController/activate_server',

ipdOrderTreatmentUrl: "web_apis/ipd_order_treatment",




// Read APIs
getAuditLogUrl:    "get_audit_log",
auditDetailUrl:    "audit_detail",
auditStatsUrl:     "audit_stats",
exportAuditLogUrl: "export_audit_log",
clearOldLogsUrl:   "clear_old_logs",

// ✅ NEW: Restore deleted record
restoreRecordUrl:  "restore_record",

// Audited DELETE endpoints — use these instead of the old delete URLs
deleteLabPaymentUrl: "delete_lab_payment",
deleteLabRegUrl:     "delete_lab_reg",
deleteLabItemUrl:    "delete_lab_item",

deleteEmergencyUrl:  "delete_emergency",
// Add this to appconst.js


deleteIpdUrl:        "delete_ipd",
deleteOpdUrl:        "delete_opd",
deleteOtUrl:         "delete_ot",
deleteMedBillUrl:    "delete_med_bill",
deleteMedPaymentUrl: "delete_med_payment",
deleteMedReturnUrl:  "delete_med_return",

// Edit log endpoints — call after your existing edit succeeds
logEditLabRegUrl:    "log_edit_lab_reg",
logEditIpdUrl:       "log_edit_ipd",
logEditOpdUrl:       "log_edit_opd",
logEditEmergencyUrl: "log_edit_emergency",
logEditMedBillUrl:   "log_edit_med_bill",
logEditOtUrl:        "log_edit_ot",
logEditPurchaseUrl:  "log_edit_purchase",







};

export default AppConst;